import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import { withRouter } from '../../../../../withRouter'
import { history } from '../../../../../store'

import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../../../common/utils'
import { ProfileBadge } from '../../../../../components/generic'

export function MARChartMedicationCell(props) {
  const {
    medication: { controlledDrug, deleted, id, PRN, resident },
    name,
  } = props

  return (
    <div
      className={css(classes.medicationCell, deleted && classes.greyed)}
      onClick={() => history.push(`/residents/${resident}/emar/${id}/chart`)}
    >
      {name}
      {!deleted && controlledDrug && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.red, 0.2)}
          badgeStyle={styles.badge}
          badgeText="CD"
          textColor={colors.red}
        />
      )}
      {!deleted && PRN && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.blue, 0.2)}
          badgeStyle={styles.badge}
          badgeText="PRN"
          textColor={colors.blue}
        />
      )}
      {deleted && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.darkgrey, 0.2)}
          badgeStyle={styles.badge}
          badgeText="Discontinued"
          textColor={colors.darkgrey}
        />
      )}
    </div>
  )
}

const classes = StyleSheet.create({
  greyed: {
    color: colors.grey,
  },
  medicationCell: {
    display: 'flex',
    paddingLeft: 12,
    ':hover': {
      cursor: 'pointer',
      color: colors.primary,
    },
  },
})

const styles = {
  badge: {
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 8,
    padding: '3px 12px',
    borderRadius: 15,
  },
}

export default withRouter(MARChartMedicationCell)
